// Env vars are referenced literally so Next.js can inline them in client bundles
const WEBSITE_URLS: Record<string, string> = {
  de: process.env.NEXT_PUBLIC_WEBSITE_PUBLIC_URL_GERMAN,
  en: process.env.NEXT_PUBLIC_WEBSITE_PUBLIC_URL_ENGLISH,
  pl: process.env.NEXT_PUBLIC_WEBSITE_PUBLIC_URL_POLISH,
}

/** Public website URL (origin) for a locale, falls back to the German website */
export const getWebsiteUrl = (locale?: string) =>
  new URL((locale && WEBSITE_URLS[locale]) || WEBSITE_URLS.de)
